<template>
  <div class="notes-container">
    Notes
  </div>
</template>

<script>
export default {
  name: 'Notes',
  props: ["content"],
  mounted() {
  },
  methods: {
  }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style lang="scss" scoped>
</style>